<div class="row" *ngIf="productLines">
  <div class="ir-area ir-mask th-mask">
    <form class="ir-modal th-modal" (ngSubmit)="save(newForm.value)" [formGroup]="newForm">
      <div class="ir-modal--title">
        <div class="ir-line">
          <div class="ir-line-content">
            <span>{{ 'people.new-person' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
        <div class="ir-content--modal th-content">
          <table class="ir-modal-table">
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'common.name' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <input type="text" name="Name" class="ir-form-set" formControlName="Name" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'common.description' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <input type="text" name="Description" class="ir-form-set" formControlName="Description" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'people.phone' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <input type="text" name="Phone" class="ir-form-set" formControlName="Phone" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'people.username' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <input type="text" name="UserName" class="ir-form-set" formControlName="UserName" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'people.email' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <input type="email" name="Email" class="ir-form-set" formControlName="Email" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'people.language' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <select name="Language" class="ir-form-set" formControlName="Language">
                    <option *ngFor="let language of languages | orderBy: 'name'" [value]="language.value">
                      {{ language.label }}
                    </option>
                  </select>
                </div>
              </td>
            </tr>
            <tr class="th-plugin-line--input" *ngIf="currentPerson.isHost">
              <td style="width: 25%">
                <span>Applications</span>
              </td>
              <td class="th-plugin-line--value">
                <div
                  class="ir-item-line clickable indent nobreak"
                  *ngFor="let applicationType of applicationTypes; let last = last"
                  (click)="updateApplicationTypes(applicationType.Value)"
                >
                  <div class="ir-item-cell">
                    <div class="ir-item-selector">
                      <i class="material-icons" *ngIf="!isInPersonApplicationTypes(applicationType.Value)"
                        >check_box_outline_blank</i
                      >
                      <i class="material-icons" *ngIf="isInPersonApplicationTypes(applicationType.Value)">check_box</i>
                    </div>
                    <span>{{ applicationType.Label | translate }}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr style="display: none">
              <td class="margin-big" style="width: 25%">
                <span>{{ 'people.office.name' | translate }}</span>
              </td>
              <td class="th-plugin-line--value margin-big">
                <div class="ir-line ir-select th-select" (click)="openOfficeSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      newForm.controls.office.value
                        ? (newForm.controls.office.value | localEntity)
                        : ('people.office.select-office' | translate)
                    }}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big" style="width: 25%">
                <span>Profiles</span>
              </td>
              <td class="th-plugin-line--value margin-big">
                <div class="ir-line ir-select th-select" (click)="openPermissionsSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHtml]="getSelectedValues()"></span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big" style="width: 25%">
                <span>{{ 'people.localEntities' | translate }}</span>
              </td>
              <td class="th-plugin-line--value margin-big">
                <div class="ir-line ir-select th-select" (click)="openLocalEntitiesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHtml]="getSelectedLocalEntitiesValues()"></span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td style="width: 25%">
                <span>{{ 'plugins.equipment-info.product-line' | translate }}</span>
              </td>
              <td class="th-plugin-line--value">
                <div class="ir-line ir-select th-select" (click)="openProductLinesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHtml]="getSelectedProductLineValues()"></span>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="ir-modal--footer ir-position--b th-modal--footer">
        <div class="ir-row">
          <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
            <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
              <span>{{ 'common.cancel' | translate }}</span>
            </div>
          </div>
          <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
            <button
              class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
              type="submit"
              [disabled]="newForm.invalid"
              *ngIf="!processing"
            >
              <span>{{ 'common.save-changes' | translate }}</span>
            </button>
            <button
              class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
              type="submit"
              *ngIf="processing"
            >
              <span>{{ 'common.processing' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<modal
  (modalOutput)="selectProductLinesMenu($event)"
  (modalClosed)="onProductLinesMenuClose($event)"
  #productLinesModal
></modal>
<modal (modalOutput)="selectPermissionsMenu($event)" #permissionsModal></modal>
<modal (modalOutput)="selectLocalEntitiesMenu($event)" #localEntitiesModal></modal>
<modal (modalOutput)="selectOfficeMenu($event)" #officeModal></modal>
